import { getIn } from "formik";
import { useFGContext } from "nsitools-react";
import * as React from "react";
import { FGWalterSelectInput } from "..";
import { EFormePersonne, ReferentialApi } from "../../api";
import { useTl } from "../../hooks";
import { useReferential } from "../../hooks/useReferential";
import { ETLCodes } from "../../locales";

export interface ISuiviSiegeLieuContactSelectProps {
  forme: EFormePersonne;
}

export const SuiviSiegeLieuContactSelect: React.FunctionComponent<ISuiviSiegeLieuContactSelectProps> = ({ forme }) => {
  const { t } = useTl();
  const { formik } = useFGContext();

  const fetchRef = React.useCallback(
    (a: ReferentialApi) => {
      switch (forme) {
        case EFormePersonne.Contact:
          return formik.values?.idlieuFormation
            ? a.referentialGetContactLieuFormation({ idlieuFormation: formik.values?.idlieuFormation })
            : a.referentialGetContactSiegeSocial({ idSiegeSocial: formik.values?.idsiegeSocial });
        case EFormePersonne.Tuteur:
          return a.referentialGetTuteurLieuFormation({ idlieuFormation: formik.values?.idlieuFormation });
        case EFormePersonne.ChefEntreprise:
          return a.referentialGetChefEntrepriseSiegeSociaux({ idSiegeSocial: formik.values?.idsiegeSocial });
        default:
          return null;
      }
    },
    [forme, formik.values?.idlieuFormation, formik.values?.idsiegeSocial]
  );
  const [contacts, cLoading] = useReferential(fetchRef, true, [
    formik.values?.idsiegeSocial,
    formik.values?.idlieuFormation
  ]);

  const name = React.useMemo(() => {
    switch (forme) {
      case EFormePersonne.Contact:
        return "idcontact";
      case EFormePersonne.Tuteur:
        return "idtuteur";
      case EFormePersonne.ChefEntreprise:
        return "idchefEntreprise";
      default:
        return null;
    }
  }, [forme]);

  const label = React.useMemo(() => {
    switch (forme) {
      case EFormePersonne.Contact:
        return t(ETLCodes.Contact);
      case EFormePersonne.Tuteur:
        return t(ETLCodes.Tuteur);
      case EFormePersonne.ChefEntreprise:
        return t(ETLCodes.ChefEntreprise);
      default:
        return null;
    }
  }, [t, forme]);

  const canDisplay = React.useMemo(() => {
    switch (forme) {
      case EFormePersonne.Contact:
        return !!formik.values?.idlieuFormation || !!formik.values?.idsiegeSocial;
      case EFormePersonne.Tuteur:
        return !!formik.values?.idlieuFormation;
      case EFormePersonne.ChefEntreprise:
        return !!formik.values?.idsiegeSocial;
      default:
        return false;
    }
  }, [forme, formik.values?.idlieuFormation, formik.values?.idsiegeSocial]);

  return (
    !!name &&
    canDisplay && (
      <FGWalterSelectInput
        name={name}
        label={label}
        items={contacts}
        loading={cLoading}
        readonly={formik.values?.idsuivi > 0 && getIn(formik.values, name)}
      />
    )
  );
};

export default SuiviSiegeLieuContactSelect;
